var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"r-identicon"},[_c('img',{style:({height: _vm.size, width: _vm.size}),attrs:{"src":_vm.src || require('@/assets/images/reclaim/mystery.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }